import styled from '@emotion/styled';

export const Box = styled.div`
  padding: 16px;
  border-width: 0 0 1px;

  border-style: solid;
  border-color: ${({ theme }) => theme.colors.zinc_200};

  background: ${({ theme }) => theme.colors.white};

  &.last {
    border-width: 0;
    border-radius: 0 0 8px 8px;
  }
`;
